import React from "react";
import CodigoSenha from "../../../../components/acesso-rapido/cartoes/cartao-senha/CartaoSenha";

export default function () {
  return <CodigoSenha />;
}
